// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Gy2r","bigColWidth":"Table_bigColWidth__3GPca","biggerColWidth":"Table_biggerColWidth__1yoTK","row":"Table_row__S_c9J","col":"Table_col__3HaP7"};